import React, { useState } from "react";
import PropTypes from "prop-types";
import "./SharedTabPanel.css";

/**
 * Reusable Tab Panel Component.
 * @param {Array} tabs - Array of objects: { id: number|string, label: string, content: ReactNode }
 * @param {number|string} defaultActiveTab - The ID of the tab to be active by default (optional).
 */
const SharedTabPanel = ({ tabs, defaultActiveTab, transparent }) => {
  const [activeTab, setActiveTab] = useState(
    defaultActiveTab || (tabs.length > 0 ? tabs[0].id : 0),
  );

  if (!tabs || tabs.length === 0) {
    return null;
  }

  return (
    <div
      className={`shared-tabs-container ${transparent ? "transparent" : ""}`}
    >
      {/* Tabs Header */}
      <div className="shared-tabs-header">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`shared-tab-item ${activeTab === tab.id ? "active" : ""}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tabs Content */}
      <div className="shared-tab-content">
        {tabs.map((tab) => {
          if (activeTab !== tab.id) return null;
          return <div key={tab.id}>{tab.content}</div>;
        })}
      </div>
    </div>
  );
};

SharedTabPanel.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
      content: PropTypes.node.isRequired,
    }),
  ).isRequired,
  defaultActiveTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default SharedTabPanel;
